import Sample from './sample'

export default Sample
